import { Instagram, Twitter, Youtube, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-[#080808]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-serif-display text-3xl text-white">
            30<span className="gold-text">DG</span>
          </div>
          <p className="mt-3 text-sm text-neutral-500 max-w-xs">
            30 Days of Growth — a discipline system by Kendrick Callicutt.
            Become 3x better. Compound the rest.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#d4af37]/80">
            Explore
          </p>
          <ul className="mt-4 space-y-2 text-sm text-neutral-400">
            <li>
              <a href="#hero" className="hover:text-[#e5c158] transition-colors">
                The Book
              </a>
            </li>
            <li>
              <a href="#journey" className="hover:text-[#e5c158] transition-colors">
                30-Day Journey
              </a>
            </li>
            <li>
              <a href="#author" className="hover:text-[#e5c158] transition-colors">
                About the Author
              </a>
            </li>
            <li>
              <a href="#faq" className="hover:text-[#e5c158] transition-colors">
                FAQ
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#d4af37]/80">
            Connect
          </p>
          <div className="mt-4 flex items-center gap-3">
            {[Instagram, Twitter, Youtube, Mail].map((Icon, i) => (
              <a
                key={i}
                href="#"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 rounded-full border border-white/10 hover:border-[#d4af37]/50 hover:text-[#e5c158] text-neutral-400 flex items-center justify-center transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
          <a
            href="mailto:kendrick@my30dg.com"
            data-testid="footer-email"
            className="mt-6 inline-block text-xs text-neutral-500 hover:text-[#e5c158] transition-colors"
          >
            kendrick@my30dg.com
          </a>
        </div>
      </div>

      <div className="gold-hairline" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-neutral-600">
        <span>© {new Date().getFullYear()} Kendrick Callicutt. All rights reserved.</span>
        <span>Built for the 3x standard.</span>
      </div>
    </footer>
  );
}
